// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#facet-list{transition:transform .4s}#facet-list>div{margin:2em 0}#facet-list.closed{transform:translateX(100%)}#facet-list .drawer-handle{background:var(--primary);width:2em;height:4em;border-radius:2em 0 0 2em;position:absolute;left:-2em;top:calc(50% - 4em);margin:0;display:flex;justify-content:center;align-items:center;cursor:pointer}#facet-list .drawer-handle i{color:#fff;margin-left:2px}", ""]);
// Exports
module.exports = exports;
